import banzai from 'ub/control/banzai-features';

export default {
  selectedTab: 'style',
  inEditMode: false,
  elementId: null,
  onlyVisibleInEditMode: !banzai.features.isSingleClickTextEditingEnabled(),

  textStyles: {
    strong: false,
    em: false,
    u: false,
    sub: false,
    sup: false,
    s: false,
  },
  alignment: 'left',
  listStyle: null,
  horizontalLine: false,
  fontSize: 14,
  fontWeight: 400,
  fontStyle: 'normal',
  lineHeight: 17,
  paragraphStyle: 'p',
  fontColor: { r: 0, b: 0, g: 0 },
  fontFamily: 'Arial',
  fontBackgroundColor: { r: 255, b: 255, g: 255, a: 0 },
  urlAction: 'url',
  urlValue: '',
  passParams: false,
  target: '_self',
};



// WEBPACK FOOTER //
// ./src/ui/inline-text/states/initial-state.js